<template>
  <div class="flex flex-col justify-start text-sm-12px-default text-text-subtle">
    <slot />
  </div>
</template>
